import styled from 'styled-components/macro';

export const ButtonContainer = styled.div`
  button {
    display: block;
    margin-bottom: 0.5rem;
    width: 100%;
  }

  @media only screen and (min-width: 768px) {
    display: flex;
    justify-content: space-between;

    button {
      margin-bottom: 1rem;
      width: auto;
    }
  }
`;
